/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ComponentRef, Injectable, ViewContainerRef} from '@angular/core';
import {Subscription} from 'rxjs';
import {SettlementDetailComponentsModel} from '../settlement-detail-configuration/models/settlement-detail-components.model';
import {SettlementDetailFooterConfigurationModel} from '../settlement-detail-configuration/models/settlement-detail-footer-configuration.model';
import {SettlementDetailFooterActionsEnum} from '../../models/settlement-detail-footer-actions.enum';
import {SettlementFooterComponent} from '../../settlement-footer/settlement-footer.component';
import {SettlementDetailHeaderConfigurationModel} from '../settlement-detail-configuration/models/settlement-detail-header-configuration.model';
import {SettlementDetailHeaderComponent} from '../../setttlement-detail-header/settlement-detail-header.component';
import {SettlementDetailInformationComponent} from '../../settlement-detail-information/settlement-detail-information.component';
import {SettlementDetailInformationConfigurationModel} from '../settlement-detail-configuration/models/settlement-detail-information-configuration.model';
import {SettlementAgreementComponent} from '../../settlement-agreement/settlement-agreement.component';
import {SettlementDetailAgreementConfigurationModel} from '../settlement-detail-configuration/models/settlement-detail-agreement-configuration.model';
import {SettlementDetailTitleComponent} from '../../settlemente-detail-title/settlement-detail-title.component';

@Injectable({
    providedIn: 'root'
})
export class SettlementCreateComponentService {

    private createdComponents: ComponentRef<any>[] = [];
    private subscriptions: Subscription = new Subscription;

    constructor() {
    }

    updateComponents(create: (components: SettlementDetailComponentsModel[]) => void,
                     components: SettlementDetailComponentsModel[]): void {
        if (this.createdComponents?.length > 0) {
            this.destroyComponents();
        }
        create(components);
    }

    destroyComponents(): void {
        this.createdComponents.forEach((component) => {
            component.destroy();
        });
        this.createdComponents = [];
    }

    mapHeaderSection(value: SettlementDetailHeaderConfigurationModel, container: ViewContainerRef): void {
        const component = container.createComponent(SettlementDetailHeaderComponent);

        component.instance.configuration = value;

        this.createdComponents.push(component);
    }

    mapTitleSection(value: string, container: ViewContainerRef): void {
        const component = container.createComponent(SettlementDetailTitleComponent);

        component.instance.sectionTitle = value;

        this.createdComponents.push(component);
    }

    mapInformationSection(value: SettlementDetailInformationConfigurationModel, container: ViewContainerRef): void {
        const component = container.createComponent(SettlementDetailInformationComponent);

        component.instance.configuration = value;

        this.createdComponents.push(component);
    }


    mapAgreementSection(value: SettlementDetailAgreementConfigurationModel, container: ViewContainerRef): void {
        const component = container.createComponent(SettlementAgreementComponent);

        component.instance.agreement = value;

        this.createdComponents.push(component);
    }

    mapFooterSection(value: SettlementDetailFooterConfigurationModel,
                     container: ViewContainerRef,
                     footerAction: (action: SettlementDetailFooterActionsEnum) => void): void {
        const component = container.createComponent(SettlementFooterComponent);

        component.instance.configuration = value;

        this.subscriptions.add(component.instance.action
                .subscribe((action: SettlementDetailFooterActionsEnum) => footerAction(action)));

        this.createdComponents.push(component);
    }
}
